import Vue from 'vue'
// let v = new Vue();
import axios from 'axios'
import QS from 'qs'
import router from '../router/index'

export default {
  post(url, params = {}, head) {
    const user_mobile = sessionStorage.getItem('user_mobile')
    return new Promise((resolve, reject) => {
      const headers = Object.assign({
        'content-type': 'application/json',
        'Authorization': user_mobile,
        // 'Authorization': sessionStorage.getItem("esignappsid") || "15001128696",  
      }, head)
      axios.post(url, params || {}, { headers })
        .then(res => {
          // console.log(res,'纵请求接口')
          // if (res.data.status && res.data.status === -99) {
          //   console.log('重新登录')
          //   router.push({ path: '/logins' })
          //   // console.log(res.data.msg)
          // }
          if (res.data.status != 0) {
            // console.log('接口请求错误',res.data.msg)
            // v.$message({
            //   showClose: true,
            //   message: res.data.msg,
            //   type: 'error'
            // });
          }
          resolve(res.data)
        })
        .catch(err => {
          // console.log('接口提示', err.data.msg)
          // v.$message.error(err.data.msg);
          reject(err.data)
        })
    })
  }
}
// export function get(url, params) {
//   return new Promise((resolve, reject) => {
//     axios.get(url, {
//       params: params
//     }).then(res => {
//       resolve(res.data)
//     }).catch(err => {
//       reject(err.data)
//     })
//   })
// }

// export function post(url, params) {
//   params.openid = sessionStorage.getItem("openId");
//   params.merchant_id = "11252962043000331";
//   return new Promise((resolve, reject) => {
//     axios.post(url, QS.stringify(params) || {}, {
      
//       headers: {
//         'content-type': 'application/x-www-form-urlencoded',
//       }
//     })
//       .then(res => {
//         if (res.data.status != 0) {
//           console.log('接口请求错误',res.data.msg)
//         }
//         resolve(res.data)
//       })
//       .catch(err => {
//         console.log('接口提示', err.data.msg)
//         // v.$message.error(err.data.msg);
//         reject(err.data)
//       })
//   })
// }


// WEBPACK FOOTER //
// ./src/api/index.js